"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _ArrowLeft = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLeft16"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _useFocusGroup = _interopRequireDefault(require("../common/useFocusGroup"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MAX_PAGE_BUTTONS = 7;
var FIXED_PAGE_BUTTON_COUNT = 2; // the first and last page buttons
var DISTANCE_TO_SHOW_ELLIPSIS = Math.floor(MAX_PAGE_BUTTONS / 2);
var MAX_DYNAMIC_PAGE_BUTTONS = MAX_PAGE_BUTTONS - FIXED_PAGE_BUTTON_COUNT;
var DISTANCE_TO_END = DISTANCE_TO_SHOW_ELLIPSIS + 1;
function HBTablePagination(_ref) {
  var table = _ref.table;
  var _table$getState = table.getState(),
    pageIndex = _table$getState.pagination.pageIndex;
  var pageCount = table.options.meta.isInitialLoading ? MAX_PAGE_BUTTONS : table.getPageCount();
  (0, _react.useEffect)(function () {
    if (pageIndex > pageCount - 1) {
      table.setPageIndex(pageCount - 1);
    }
  }, [pageIndex, pageCount, table]);
  var isFirstPage = pageIndex === 0;
  var isLastPage = pageIndex === pageCount - 1;
  var dynamicPageCount = pageCount - FIXED_PAGE_BUTTON_COUNT;
  var dynamicPageButtonsToRender = Math.min(dynamicPageCount, MAX_DYNAMIC_PAGE_BUTTONS);
  var hasMorePagesThanMaxVisible = dynamicPageCount > MAX_DYNAMIC_PAGE_BUTTONS;
  var hasMorePagesBefore = hasMorePagesThanMaxVisible && pageIndex > DISTANCE_TO_SHOW_ELLIPSIS;
  var hasMorePagesAfter = hasMorePagesThanMaxVisible && pageIndex <= pageCount - DISTANCE_TO_END;
  var testId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    componentName: 'HBTablePagination',
    identifier: 'pagination',
    suffix: 'container'
  });
  (0, _useFocusGroup["default"])(".".concat(CONTAINER_CLASS_NAME, " .").concat(BUTTON_CLASS_NAME));
  return /*#__PURE__*/_react["default"].createElement(Container, {
    "data-testid": testId,
    className: CONTAINER_CLASS_NAME
  }, /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    label: "",
    testIdName: "pagination-page-prev",
    buttonTheme: "subtle-invisible",
    icon: _ArrowLeft["default"],
    onClick: table.previousPage,
    disabled: isFirstPage,
    className: BUTTON_CLASS_NAME
  }), /*#__PURE__*/_react["default"].createElement(PageButton, {
    testIdName: 0,
    label: 1,
    onClick: table.firstPage,
    isSelected: isFirstPage
  }), Array.from({
    length: dynamicPageButtonsToRender
  }).map(function (_, index) {
    var updatedIndex = index + 1;
    var actualIndex = !hasMorePagesThanMaxVisible || pageIndex <= DISTANCE_TO_SHOW_ELLIPSIS ? updatedIndex : pageIndex >= pageCount - DISTANCE_TO_SHOW_ELLIPSIS ? updatedIndex + pageCount - MAX_PAGE_BUTTONS : updatedIndex + pageIndex - DISTANCE_TO_SHOW_ELLIPSIS;
    var isSecondButtonNotSecondPage = hasMorePagesBefore && index === 0;
    var isSecondToLastButtonNotSecondToLastPage = hasMorePagesAfter && index === dynamicPageButtonsToRender - 1;
    var shouldShowEllipsis = isSecondButtonNotSecondPage || isSecondToLastButtonNotSecondToLastPage;
    var label = shouldShowEllipsis ? '...' : actualIndex + 1;
    return /*#__PURE__*/_react["default"].createElement(PageButton, {
      key: index,
      testIdName: updatedIndex,
      label: label,
      isSelected: pageIndex === actualIndex,
      inert: shouldShowEllipsis,
      onClick: function onClick() {
        return table.setPageIndex(actualIndex);
      }
    });
  }), pageCount > 1 && /*#__PURE__*/_react["default"].createElement(PageButton, {
    testIdName: dynamicPageButtonsToRender + 1,
    isSelected: isLastPage,
    onClick: table.lastPage,
    label: pageCount
  }), /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    label: "",
    testIdName: "pagination-page-next",
    buttonTheme: "subtle-invisible",
    icon: _ArrowRight["default"],
    onClick: table.nextPage,
    disabled: isLastPage,
    className: BUTTON_CLASS_NAME
  }));
}
var _default = exports["default"] = HBTablePagination;
var CONTAINER_CLASS_NAME = 'pagination-container';
var BUTTON_CLASS_NAME = 'pagination-button';
var PageButton = function PageButton(_ref2) {
  var isSelected = _ref2.isSelected,
    onClick = _ref2.onClick,
    label = _ref2.label,
    inert = _ref2.inert,
    testIdName = _ref2.testIdName;
  return /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    inert: inert,
    label: "",
    testIdName: "pagination-page-".concat(testIdName),
    buttonTheme: isSelected ? 'accent-invisible' : 'subtle-invisible',
    icon: function icon() {
      return /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
        type: "emphasis14",
        color: "textTertiary"
      }, label);
    },
    onClick: onClick,
    className: BUTTON_CLASS_NAME,
    isSelected: isSelected
  });
};

// -------------------------- Styles -------------------------- //

var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBTablePagination__Container",
  componentId: "sc-7ybeqx-0"
})(["display:flex;justify-content:center;gap:4px;padding:16px;border-top:1px solid ", ";overflow:auto;"], _colors["default"].neutral300);
//# sourceMappingURL=HBTablePagination.js.map